import React from 'react';
import {withNamespaces} from "react-i18next";
import {isEmpty} from "lodash";
import moment from 'moment';
import i18n from 'i18next';


const Optimalle = ({  optimalle, t }) =>
    <li className="optimalle-item">
        <div className="top-info">
            <div className="daterange">
                <div className="nice-date">
                    <div className="day">{moment (optimalle.startAt).format('DD')}</div>
                    <div className="month">{moment (optimalle.startAt).format('MMM')}</div>
                    <div className="year">{moment (optimalle.startAt).format('YYYY')}</div>
                </div>
                <i className="fas fa-angle-right"></i>
                <div className="nice-date">
                    <div className="day">{moment (optimalle.endAt).format('DD')}</div>
                    <div className="month">{moment (optimalle.endAt).format('MMM')}</div>
                    <div className="year">{moment (optimalle.endAt).format('YYYY')}</div>
                </div>
            </div>

            {!isEmpty(optimalle.misc['bag-transport-rate']) ?
                <div className="price">
                    <span className="from">à partir de</span> {optimalle.misc['bag-transport-rate']['value']}€<span className="unit">/bagage/étape</span>
                </div>
            :
                (!isEmpty(optimalle.misc['bike-transport-rate']) ?
            <div className="price">
                <span className="from">à partir de</span> {optimalle.misc['bike-transport-rate']['value']}€<span className="unit">/vélo</span>
            </div>
            :
                    (!isEmpty(optimalle.misc['people-transport-rate']) &&
            <div className="price">
                <span className="from">à partir de</span> {optimalle.misc['people-transport-rate']['value']}€<span className="unit">/personne</span>
            </div>
                    ))}
        </div>
        <div className="route-pic" style={{
            'background-image' : "url('/assets/img/elements/bg-grey-alpha.png'), url("+optimalle.hike.picture+")"
        }}>
            <h3 className="route-title">
                {optimalle.hike.title}
            </h3>
            <div className="type">{optimalle.type == 'quotation' ? 'projet rando' : 'départ confirmé'}</div>
        </div>
        <div className="content">
            <div className="type-bloc">
                <div className="type">
                    {(!isEmpty(optimalle.misc['people-transport-rate']) &&
                        <img className="picto" src="/assets/img/icons/services/g-bus.png"/>)
                    || (!isEmpty(optimalle.misc['bike-transport-rate']) &&
                        <img className="picto" src="/assets/img/icons/services/g-bike-transport.png"/>)
                    || <img className="picto" src="/assets/img/icons/services/g-bag-transport.png"/>
                    }
                </div>
                <div className="fromto-bloc">
                    <div className="fromto-icons">
                        <i className="fa fa-circle" aria-hidden="true"/>
                        <i className="fa fa-ellipsis-v" aria-hidden="true"/>
                        <i className="fa fa-circle" aria-hidden="true"/>
                    </div>
                    <div className="steps">
                        <div className="locality">{optimalle.from.title}</div>
                        <div className="locality">{optimalle.to.title}</div>
                    </div>
                </div>
            </div>
        </div>
        <a className="more" href={`/${i18n.language}/itineraires/${optimalle.hike.slug}/optimalle/${optimalle.reference}`}>en savoir +</a>
    </li>
;

export default withNamespaces()(Optimalle);
